import React, { useContext } from 'react';
import { SprawneMiastoContext } from '../../../../components/SprawneMiastoContext';
import { useTranslation } from 'react-i18next';
import Email from './Email';
import Password from './Password';
import Language from './Language';
import DeleteAccount from './DeleteAccount';

export default function ProfileTab() {
    const Context = useContext(SprawneMiastoContext);
    const { t } = useTranslation();

    return (
        <div>
            <h1 className={'py-2'}>{t('translation:MY_ACCOUNT.PROFILE.PROFILE_SETTINGS')}</h1>
            <hr />
            <div className={'flex flex-col gap-1 py-4 md:flex-row md:gap-3'}>
                <div className={'w-full text-slate-600 md:w-1/3'}>
                    {t('translation:MY_ACCOUNT.PROFILE.USERNAME')}
                </div>

                <input
                    disabled={true}
                    className={
                        'w-full w-full  rounded border border-gray-300 px-2 py-1 outline-0 focus:border-blue-200 disabled:text-gray-500'
                    }
                    type={'text'}
                    value={Context?.user?.username}
                />
            </div>
            <hr />
            <Email />
            <hr />
            <Password />
            <hr />
            <Language />
            <hr />
            <DeleteAccount />
        </div>
    );
}
